import styled from 'styled-components';
import media from 'styled-media-query';
import { generateMedia } from 'styled-media-query';
import { Link } from 'gatsby';

const customMedia = generateMedia({
  mobile: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  laptopXL: "2560px"
})

export const LanguageWrapper = styled.ul`
  display: flex;
  
  ${media.greaterThan('medium')`
    
  `}
`;

export const LanguageItem = styled.li`
  margin-left: var(--space-sm);

  ${customMedia.greaterThan('tablet')`
    margin-left: .3rem;
  `}
`;

export const LanguageLink = styled(Link)`
  display: inline-block;
  text-transform: uppercase;
  color: var(--dark);
  font-size: 1.5rem;
  font-weight: 400;
  letter-spacing: 1px;
  padding: .5rem;

  ${customMedia.greaterThan('tablet')`
    font-size: 1.8rem;
  `}

  &.current,
  &:active, &:focus {
    color: var(--primary-color);
  }

  &:hover {
    color: var(--text-white);
    background-color: #818387;
    border-radius: 50%;
  }
`;
